/* @flow */
import Backbone from 'backbone-model';
import Collection from 'lib/Collection';
import _ from 'lodash';

import sync from './BackboneSync';

export default class Entity extends Backbone.Model {
  constructor(attrs: Object = {}, options: Object = {}): void {
    super();
    this.cid = _.uniqueId('c');
    this.attributes = {};
    if (options.collection) {
      this.collection = options.collection;
    }
    let possiblyParsedAttrs = attrs;
    if (options.parse) {
      possiblyParsedAttrs = this.parse(attrs, options) || {};
    }
    const defaultedAttrs = _.defaults({}, possiblyParsedAttrs, _.result(this, 'defaults'));
    this.initialize.call(this, defaultedAttrs, options);
    this.set(defaultedAttrs, options);
    this.changed = {};
  }

  fetch(options: Object = {}): Promise<this> {
    return new Promise((resolve, reject) => {
      options.success = resolve;
      options.error = (model, response) => {
        reject(response);
      };
      super.fetch(options);
    });
  }

  save(attributes: Object, options: Object = {}): Promise<void> {
    return new Promise((resolve, reject) => {
      options.success = resolve;
      options.error = (model, response) => {
        reject(response);
      };
      super.save(attributes, options);
    });
  }

  destroy(options: Object = {}): Promise<void> {
    return new Promise((resolve, reject) => {
      options.success = resolve;
      options.error = reject;
      super.destroy(options);
    });
  }

  sync() {
    return sync.apply(this, arguments);
  }

  jasmineToString(): string {
    return this.constructor.name + ' ' + JSON.stringify(this.attributes, null, 2);
  }

  // TODO make this safe to override toJSON
  // https://github.com/remind101/r101-frontend/pull/3877#issuecomment-239017223
  recursivelyToJSON(): Object {
    const json = super.toJSON();

    const attrKeys = Object.keys(this.attributes);

    for (const key of attrKeys) {
      const val = this.get(key);

      if (val) {
        const jsonVal = Array.isArray(val) ?
          val.map(item => serialize(item)) :
          serialize(val);
        json[key] = jsonVal;
      }
    }

    return json;
  }

  static fetch(attributes: Object = {}, options: Object = {}): Promise<this> {
    return new this(attributes).fetch(options);
  }

  static fromJSON(attributes: Object = {}): this {
    return new this(attributes, { parse: true });
  }
}

function serialize(val: mixed): mixed {
  if ((val instanceof Entity) || (val instanceof Collection)) {
    return val.toJSON();
  } else {
    return val;
  }
}



// WEBPACK FOOTER //
// ./src/lib/Entity.js